import React, { useEffect, useContext, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import Loading from 'components/Loading';
import Public from 'components/PublicContainer';
import { AssociadoRoutePath } from 'library/Routes';
import { authActionsLogin } from 'store/modules/AuthActions';
import AppContext from 'App.context';

export default function () {
  const { associadoManager } = useContext(AppContext);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const login = useCallback(async () => {
    if (!associadoManager) return;
    const user = await associadoManager.signinRedirectCallback();
    await associadoManager.storeUser(user);
    dispatch(authActionsLogin(user.id_token, () => history.replace(AssociadoRoutePath)));
  }, [dispatch, history, associadoManager]);

  const redirect = useCallback(async () => {
    if (!associadoManager) return;
    await associadoManager.signinRedirect();
  }, [associadoManager]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.has('state')) {
      login().catch(() => {
        redirect();
      });
    } else {
      redirect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [associadoManager]);

  return (
    <Public readOnly>
      <Loading />
    </Public>
  );
}
